/**
 * MC Collection Hero — Slideshow Controller
 * Auto-advancing carousel with dot + arrow navigation.
 * Initialises when [data-mc-col-hero-slider] exists with 2+ slides.
 * Default auto-play: 3 seconds (configurable via data-autoplay).
 */
(function () {
  "use strict";
  window._mcHeroJSLoaded = true;

  class McCollectionHeroSlider {
    constructor(el) {
      this.root = el;
      this.track = el.querySelector("[data-slider-track]");
      this.slides = [...el.querySelectorAll("[data-slider-slide]")];
      this.dots = [...el.querySelectorAll("[data-slider-dot]")];
      this.prevBtn = el.querySelector("[data-slider-prev]");
      this.nextBtn = el.querySelector("[data-slider-next]");

      if (this.slides.length < 2) return;

      this.current = 0;
      this.total = this.slides.length;
      this.autoInterval = parseInt(el.dataset.autoplay, 10) || 3000;
      this.timer = null;

      this._bind();
      this._startAutoplay();
    }

    _bind() {
      if (this.prevBtn)
        this.prevBtn.addEventListener("click", () => this.prev());
      if (this.nextBtn)
        this.nextBtn.addEventListener("click", () => this.next());
      this.dots.forEach((dot, i) => {
        dot.addEventListener("click", () => this.goTo(i));
      });

      /* Pause on hover */
      this.root.addEventListener("mouseenter", () => this._stopAutoplay());
      this.root.addEventListener("mouseleave", () => this._startAutoplay());

      /* Swipe support for mobile */
      let startX = 0;
      this.track.addEventListener(
        "touchstart",
        (e) => {
          startX = e.touches[0].clientX;
          this._stopAutoplay();
        },
        { passive: true },
      );
      this.track.addEventListener(
        "touchend",
        (e) => {
          const diff = startX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 50) {
            diff > 0 ? this.next() : this.prev();
          }
          this._startAutoplay();
        },
        { passive: true },
      );
    }

    goTo(index) {
      this.current = ((index % this.total) + this.total) % this.total;
      this.track.style.transform = `translateX(-${this.current * 100}%)`;
      this.dots.forEach((d, i) =>
        d.classList.toggle("is-active", i === this.current),
      );
    }

    next() {
      this.goTo(this.current + 1);
    }
    prev() {
      this.goTo(this.current - 1);
    }

    _startAutoplay() {
      this._stopAutoplay();
      this.timer = setInterval(() => this.next(), this.autoInterval);
    }

    _stopAutoplay() {
      if (this.timer) clearInterval(this.timer);
    }

    destroy() {
      this._stopAutoplay();
    }
  }

  /* ---------- Init / Re-init ---------- */
  function init() {
    document.querySelectorAll("[data-mc-col-hero-slider]").forEach((el) => {
      if (!el._mcSliderInit) {
        el._mcSliderInit = true;
        el._mcSliderInstance = new McCollectionHeroSlider(el);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  /* Re-init after AJAX hero swap */
  document.addEventListener("mc:hero:reload", () => {
    /* Clear old flag so the new slider element can be initialised */
    document.querySelectorAll("[data-mc-col-hero-slider]").forEach((el) => {
      if (el._mcSliderInstance) {
        el._mcSliderInstance.destroy();
      }
      el._mcSliderInit = false;
      el._mcSliderInstance = null;
    });
    init();
  });
})();
